import { reduce } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";

interface DisLikedSongsStore {
  songs: object;
  setSongs: (songs: Song[]) => void;
  setDislikeToSong: (songId: string) => void;
  removeDislikeFromSong: (songId: string) => void;
}

const disLikedSongsStore = create<DisLikedSongsStore>((set) => ({
  songs: new Set<Song>(),

  setSongs: (songs: Song[]) => {
    const objectToStore = reduce(
      songs,
      (acc, song) => ({
        ...acc,
        [song.id]: true,
      }),
      {}
    );
    set({ songs: objectToStore });
  },

  setDislikeToSong: (songId: string) => {
    set((state) => {
      const status = !state.songs[songId];
      const updatedObject = { ...state.songs, [songId]: status };
      return { songs: updatedObject };
    });
  },

  removeDislikeFromSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: false };
      return { songs: updatedObject };
    });
  },
}));

export default disLikedSongsStore;
